<template>
  <TarjetaDatos titulo="Vehículo">
    <Campo2L :valor="poliza.tipoVehDesc" etiqueta="Tipo" />
    <Campo2L :valor="poliza.subtipoVehDesc" etiqueta="Subtipo" />
    <Campo2L :valor="poliza.numSerieVeh" etiqueta="Número de Serie" />
    <Campo2L :valor="poliza.anhoFabricacionVeh" etiqueta="Año Fabricación" />
    <Campo2L :valor="poliza.valorVeh + '€'" etiqueta="Valor" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
